<div class="w-full px-2 lg:px-4 bg-[#fff] rounded-lg py-2 mt-2">
  <div class="sm:flex items-center justify-between gap-2">
    <p class="text-0d5bab font-bold text-[13px] sm:text-sm lg:text-base xl:text-lg capitalize mb-2 sm:mb-0">Day Summary
    </p>
    <div class="flex flex-wrap items-center justify-start gap-2">
      <!-- all firms -->
      <select [(ngModel)]="selectedFirmId" (change)="onFilterChange()"
        class="cursor-pointer bg-[#fff] border border-d9d9d9 rounded-md ps-1 2xl:ps-2 pe-7 py-2 text-[13px] text-383838">
        <option *ngIf="firms.length > 1" value="">All Firms</option>
        <option *ngFor="let firm of firms" [value]="firm.id">
          {{ firm.name }}
        </option>
      </select>
      <!-- date from -->
      <div class="relative">
        <input type="date" [(ngModel)]="fromDate" (change)="onFilterChange()"
          class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-[#fff] rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner">
        <label
          class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-[#fff] px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">From</label>
      </div>
      <!-- date to -->
      <div class="relative">
        <input type="date" [(ngModel)]="toDate" (change)="onFilterChange()"
          class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-[#fff] rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner">
        <label
          class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-[#fff] px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">To</label>
      </div>
      <!-- Export button -->
      <button (click)="exportToExcel()"
        class="cursor-pointer capitalize rounded-md border border-898989 bg-[#fff] text-898989 text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center hover:shadow-sm transition text-nowrap">Export</button>
      <!-- Print button -->
      <button (click)="printDaybook()"
        class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center hover:shadow-sm transition">Print</button>
    </div>
  </div>

  <div class="bg-f9f9f9 flex flex-wrap items-center justify-end gap-1 sm:gap-2 p-2 mt-2">
    <!-- Cashflow -->
    <button (click)="setTab('cashflow')"
      [ngClass]="activeTab === 'cashflow' ? 'bg-metal-settled-blue text-[#fff]' : 'bg-[#fff] text-757575'"
      class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px] font-medium px-1 sm:px-2 lg:px-4 py-1">
      Cashflow
    </button>
    <!-- Sale Report -->
    <button (click)="setTab('sale')"
      [ngClass]="activeTab === 'sale' ? 'bg-metal-settled-blue text-[#fff]' : 'bg-[#fff] text-757575'"
      class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px] font-medium px-1 sm:px-2 lg:px-4 py-1">
      Sale Report
    </button>
    <!-- Purchase -->
    <button (click)="setTab('purchase')"
      [ngClass]="activeTab === 'purchase' ? 'bg-metal-settled-blue text-[#fff]' : 'bg-[#fff] text-757575'"
      class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px] font-medium px-1 sm:px-2 lg:px-4 py-1">
      Purchase
    </button>
    <!-- Old Metal -->
    <button (click)="setTab('oldMetal')"
      [ngClass]="activeTab === 'oldMetal' ? 'bg-metal-settled-blue text-[#fff]' : 'bg-[#fff] text-757575'"
      class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px] font-medium px-1 sm:px-2 lg:px-4 py-1">
      Metal
    </button>
    <!-- Orders -->
    <button (click)="setTab('orders')"
      [ngClass]="activeTab === 'orders' ? 'bg-metal-settled-blue text-[#fff]' : 'bg-[#fff] text-757575'"
      class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px] font-medium px-1 sm:px-2 lg:px-4 py-1">
      Orders
    </button>
    <!-- Udhaar -->
    <button (click)="setTab('udhaar')"
      [ngClass]="activeTab === 'udhaar' ? 'bg-metal-settled-blue text-[#fff]' : 'bg-[#fff] text-757575'"
      class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px] font-medium px-1 sm:px-2 lg:px-4 py-1">
      Udhaar
    </button>
    <!-- Expense -->
    <button (click)="setTab('expense')"
      [ngClass]="activeTab === 'expense' ? 'bg-metal-settled-blue text-[#fff]' : 'bg-[#fff] text-757575'"
      class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px] font-medium px-1 sm:px-2 lg:px-4 py-1">
      Expense
    </button>

    <!-- all Panels -->
    <div class="relative inline-block w-max">
      <div (click)="toggleDropdown()"
        class="cursor-pointer rounded-md border border-ddd text-[13px] lg:text-[15px]
           text-757575 font-medium px-1 sm:px-2 lg:ps-4 lg:pe-2 py-1 flex justify-between items-center gap-1 bg-[#fff]">
        All Panels
        <span class="text-xs"><svg width="22" height="8" viewBox="0 0 24 12" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2204_34756)">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M11.2884 10.1569L5.63137 4.49994L7.04537 3.08594L11.9954 8.03594L16.9454 3.08594L18.3594 4.49994L12.7024 10.1569C12.5148 10.3444 12.2605 10.4497 11.9954 10.4497C11.7302 10.4497 11.4759 10.3444 11.2884 10.1569Z"
                fill="#757575" />
            </g>
            <defs>
              <clipPath id="clip0_2204_34756">
                <rect width="12" height="24" fill="#fff" transform="matrix(0 1 -1 0 24 0)" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </div>

      <!-- Overlay -->
      <div *ngIf="showPanelDropdown" (click)="showPanelDropdown=false" class="fixed inset-0 z-40">
      </div>

      <!-- Dropdown -->
      <div *ngIf="showPanelDropdown" (click)="$event.stopPropagation()"
        class="absolute right-0 z-50 mt-2 w-72 sm:w-150 lg:w-180 bg-[#fff] border border-ddd rounded-lg shadow-lg p-2 lg:p-3">

        <!-- Panels Grid -->
        <div
          class="grid grid-cols-2 sm:grid-cols-3 gap-x-2 gap-y-2 text-xs md:text-[13px] lg:text-sm font-medium text-757575">
          <label *ngFor="let panel of panels" class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" class="mt-1" [checked]="isChecked(panel)" (change)="togglePanel(panel)" />
            <span>{{ panel }}</span>
          </label>
        </div>

        <!-- Actions -->
        <div class="flex justify-center gap-2 mt-4">
          <button (click)="reset()"
            class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium px-2 sm:px-4 lg:px-6 py-1 text-center">
            Reset
          </button>
          <button (click)="submit()"
            class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium px-2 sm:px-4 lg:px-6 py-1 text-center">
            Submit
          </button>
        </div>
      </div>
    </div>

  </div>

  <div class="sm:flex items-center justify-start flex-wrap gap-2 lg:gap-3 2xl:gap-5 mt-3">
    <!-- Dynamic Balances -->
    <div *ngFor="let balance of headerBalances"
      class="flex items-center justify-between sm:justify-start gap-1 md:gap-2">
      <!-- Left label -->
      <span class="text-gray-800 font-semibold text-sm md:text-base whitespace-nowrap">
        {{ balance.name }} :
      </span>
      <!-- Right input box -->
      <div class="relative">
        <input type="text" [value]="getDisplayAmount(balance)" readonly
          class="block px-2.5 py-2 w-40 sm:w-32 md:w-36 lg:w-48 xl:w-56 font-semibold text-sm md:text-[15px] text-1e1e1e placeholder:text-757575 bg-transparent rounded-md border border-d4d4d4 appearance-none focus:outline-none focus:ring-0 focus:border-018f37 peer" />
        <!-- Eye icon -->
        <button type="button" (click)="toggleAmount(balance.id)"
          class="cursor-pointer absolute right-1.5 top-1/2 -translate-y-1/2">
          <!-- Eye Open -->
          <svg class="stroke-1c1c1c hover:stroke-c19725" *ngIf="balanceVisibility[balance.id]" width="18" height="18"
            viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 3.75C4.917 3.75 2.64825 6.9255 1.842 8.337C1.67625 8.6265 1.59375 8.772 1.602 8.988C1.61175 9.204 1.70925 9.345 1.9035 9.627C2.8635 11.0205 5.4705 14.25 9 14.25C12.5295 14.25 15.1365 11.0205 16.0965 9.627C16.2915 9.345 16.389 9.204 16.3973 8.988C16.4055 8.772 16.3238 8.6265 16.158 8.337C15.3525 6.9255 13.083 3.75 9 3.75Z"
              stroke-width="0.75" />
            <path
              d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
              stroke-width="0.75" />
          </svg>

          <!-- Eye Closed -->
          <svg class="stroke-1c1c1c hover:stroke-c19725" *ngIf="!balanceVisibility[balance.id]" width="18" height="18"
            viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.0475 3.80475C8.36368 3.76814 8.68171 3.74986 9 3.75C12.498 3.75 15.3 5.92725 16.5 9C16.2095 9.74742 15.817 10.4511 15.3337 11.091M4.89 4.88925C3.36 5.823 2.175 7.26975 1.5 9C2.7 12.0728 5.502 14.25 9 14.25C10.4491 14.2576 11.8719 13.863 13.11 13.11M7.41 7.41C7.20105 7.61895 7.0353 7.86701 6.92222 8.14002C6.80914 8.41302 6.75093 8.70563 6.75093 9.00113C6.75093 9.29663 6.80914 9.58923 6.92222 9.86224C7.0353 10.1352 7.20105 10.3833 7.41 10.5923C7.61895 10.8012 7.86701 10.9669 8.14001 11.08C8.41302 11.1931 8.70563 11.2513 9.00113 11.2513C9.29662 11.2513 9.58923 11.1931 9.86224 11.08C10.1352 10.9669 10.3833 10.8012 10.5923 10.5923"
              stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 3L15 15" stroke-width="0.75" stroke-linecap="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="w-full mt-3 space-y-3">

    <!-- Cashflow -->
    <div>
      <app-cashflow #cashflowComp *ngIf="!activeTab || activeTab === 'cashflow'" [firmId]="selectedFirmId"
        [fromDate]="fromDate" [toDate]="toDate" [isGst]="isGst" (balancesLoaded)="onBalancesLoaded($event)">
      </app-cashflow>
    </div>

    <!-- Sale -->
    <div>
      <app-sale-report #saleComp *ngIf="!activeTab || activeTab === 'sale'" [firmId]="selectedFirmId"
        [fromDate]="fromDate" [toDate]="toDate">
      </app-sale-report>
    </div>

    <!-- Purchase -->
    <div>
      <app-purchase #purchaseComp *ngIf="!activeTab || activeTab === 'purchase'" [firmId]="selectedFirmId"
        [fromDate]="fromDate" [toDate]="toDate" [isGst]="isGst" (balancesLoaded)="onBalancesLoaded($event)">
      </app-purchase>
    </div>

    <!-- Old Metal -->
    <div>
      <app-old-metal #oldMetalComp *ngIf="!activeTab || activeTab === 'oldMetal'" [firmId]="selectedFirmId"
        [fromDate]="fromDate" [toDate]="toDate" (balancesLoaded)="onBalancesLoaded($event)">
      </app-old-metal>
    </div>

    <!-- Orders -->
    <div>
      <app-orders #ordersComp *ngIf="!activeTab || activeTab === 'orders'" [firmId]="selectedFirmId"
        [fromDate]="fromDate" [toDate]="toDate" (balancesLoaded)="onBalancesLoaded($event)">
      </app-orders>
    </div>

    <div>
      <app-udhaar #udhaarComp *ngIf="!activeTab || activeTab === 'udhaar'" [firmId]="selectedFirmId"
        [fromDate]="fromDate" [toDate]="toDate" [isGst]="isGst" (balancesLoaded)="onBalancesLoaded($event)">
      </app-udhaar>
    </div>

    <!-- Expense -->
    <div>
      <app-expense #expenseComp *ngIf="!activeTab || activeTab === 'expense'" [firmId]="selectedFirmId"
        [fromDate]="fromDate" [toDate]="toDate" [isGst]="isGst" (balancesLoaded)="onBalancesLoaded($event)">
      </app-expense>
    </div>
  </div>
</div>